export default __webpack_public_path__ + "static/media/bakan.ad6a67bc.jpg";